import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import Reveal from "./Reveal";
import { useLang } from "../context/LanguageContext";

export default function TurinExperience({ experiences = [] }) {
  const { t, r, lang } = useLang();
  const items = experiences.slice(0, 4);

  return (
    <section className="relative py-24 lg:py-40 bg-[#09090b]" data-testid="turin-experience-section">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <Reveal>
            <div className="overline mb-4">{t.turin.overline}</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1] max-w-xl">
              {t.turin.title.split("\n").map((l, i) => (
                <span key={l || `turin-line-${i}`} className="block">{l}</span>
              ))}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-md text-white/70 text-base leading-relaxed">{t.turin.subtitle}</p>
          </Reveal>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-12 gap-4 lg:gap-6">
          {items.map((exp, i) => {
            const title = lang === "it" ? exp.title_it : exp.title_en;
            const short = lang === "it" ? exp.short_it : exp.short_en;
            const slug = lang === "it" ? exp.slug_it : exp.slug_en;
            const layouts = [
              "col-span-12 md:col-span-7 row-span-2 aspect-[4/5] md:aspect-auto md:h-[540px]",
              "col-span-12 md:col-span-5 aspect-[4/3] md:h-[260px]",
              "col-span-6 md:col-span-5 aspect-square md:h-[260px]",
              "col-span-6 md:col-span-5 aspect-square md:h-[260px] hidden md:block",
            ];
            return (
              <Reveal key={exp.id} delay={i * 0.1} className={layouts[i] || "col-span-6"}>
                <Link
                  to={`${r.experience}#${slug}`}
                  data-testid={`experience-card-${slug}`}
                  className="on-image card-hover relative group block w-full h-full overflow-hidden border border-white/10 hover:border-[#C5A059]/50 transition-colors"
                >
                  <img src={exp.cover} alt={title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                  <div className="absolute inset-0 p-6 lg:p-8 flex flex-col justify-end">
                    <div className="overline mb-2 text-white/70">{exp.category}</div>
                    <h3 className="font-serif text-2xl lg:text-4xl leading-tight">{title}</h3>
                    <p className="mt-2 text-sm text-white/75 max-w-md leading-relaxed">{short}</p>
                    <div className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#C5A059]">
                      {t.cta.discover} <ArrowRight size={14} />
                    </div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
